import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LpLeverageService {
  readonly MILLIS_PER_DAY = 1000*60*60*24;
  readonly DAYS_IN_YEAR = 365;

  constructor() {}
  // input:
  // x1: distribution
  // x2: appriciation
  genData(x1: number, x2: number, numberOfTicks: number) {
    const dates = [
      new Date(2021, 2, 15),
      new Date(2021, 5, 15),
      new Date(2021, 8, 15),
      new Date(2021, 11, 15),
      new Date(2022, 2, 15),
      new Date(2022, 5, 15),
      new Date(2022, 8, 15),
      new Date(2022, 11, 15),
      new Date(2023, 2, 15),
      new Date(2023, 5, 15),
      new Date(2023, 8, 15),
      new Date(2023, 11, 15),
      new Date(2024, 2, 15),
      new Date(2024, 5, 15),
      new Date(2024, 8, 15),
      new Date(2024, 11, 15),
      new Date(2025, 2, 15),
      new Date(2025, 5, 15),
      new Date(2025, 8, 15),
      new Date(2025, 11, 15),
      new Date(2026, 2, 15),
    ];
    // B39: Senior LTV
    const B39 = 0.7;
    // B40: Distributions % of equity (quarterly)
    const B40 = x1 / 4;
    // B41: Property appreciation (quarterly)
    const B41 = x2 / 4;
    // B42: Investment appreciation (quarterly)
    const B42 = B41 / (1 - B39);
    //const B42 = 0.025;
    // B44: Junior Loan Interest Rate
    const B44 = 0.08;
    const B47 = 180000;
    const B48 = 60000;
    const B49 = B47 + B48;
    const J49 = B47;
    // With Leverage:
    // --------------
    const DISTRIBUTIONS1 = B40 * B49;
    const INTEREST1 = (B48 * B44) / 4;
    const CASHFLOW1 = DISTRIBUTIONS1 - INTEREST1;
    // values array
    const values1 = [B49];
    for (let i = 1; i < numberOfTicks; i++) {
      values1.push(values1[i - 1] * (1 + B42));
    }
    // Cashflow
    const cashflow1 = [0 - B47];
    for (let i = 1; i < numberOfTicks - 1; i++) {
      cashflow1.push(CASHFLOW1);
    }
    cashflow1.push(
      Math.ceil(values1[numberOfTicks - 1] + DISTRIBUTIONS1 - INTEREST1 - B48)
    );
    var sumCashflow1 = cashflow1.reduce(function (pv, cv) {
      return pv + cv;
    }, 0);
    console.log(cashflow1);
    console.log(sumCashflow1);
    // accum distributions & interest array
    const accum1 = [0];
    for (let i = 1; i < numberOfTicks; i++) {
      accum1[i] = DISTRIBUTIONS1 - INTEREST1 + accum1[i - 1];
    }
    // expected gains with leverage
    const gains1 = [0];
    for (let i = 1; i < numberOfTicks; i++) {
      gains1[i] = Math.ceil(values1[i] - B49 + accum1[i]);
    }
    // Without Leverage:
    // -----------------
    const DISTRIBUTIONS2 = J49 * B40;
    const INTEREST2 = 0;
    const CASHFLOW2 = DISTRIBUTIONS2;
    // values array
    const values2 = [J49];
    for (let i = 1; i < numberOfTicks; i++) {
      values2.push(values2[i - 1] * (1 + B42));
    }
    // Cashflow
    const cashflow2 = [0 - B47];
    for (let i = 1; i < numberOfTicks - 1; i++) {
      cashflow2.push(CASHFLOW2);
    }
    cashflow2.push(
      Math.ceil(values2[numberOfTicks - 1] + DISTRIBUTIONS2 - INTEREST2)
    );
    var sumCashflow2 = cashflow2.reduce(function (pv, cv) {
      return pv + cv;
    }, 0);
    console.log(cashflow2);
    console.log(sumCashflow2);
    // accum distributions & interest array
    const accum2 = [0];
    for (let i = 1; i < numberOfTicks; i++) {
      accum2[i] = DISTRIBUTIONS2 - INTEREST2 + accum2[i - 1];
    }
    // expected gains with leverage
    const gains2 = [0];
    for (let i = 1; i < numberOfTicks; i++) {
      gains2[i] = Math.ceil(values2[i] - J49 + accum2[i]);
    }
    const result = {
      dates: dates,
      withLeverage: {
        gains: gains1,
        cashflow: cashflow1,
        sumCashflow: sumCashflow1,
      },
      withoutLeverage: {
        gains: gains2,
        cashflow: cashflow2,
        sumCashflow: sumCashflow2,
      },
    };
    console.log(result);
    return result;
  }

  calculateXirr(transactions) {
    return this.xirr(transactions, undefined);
  }

  private newtonRaphson(f, fp, x0, options) {
    var x1, y, yp, tol, maxIter, iter, yph, ymh, yp2h, ym2h, h, hr, verbose, eps;

    // Iterpret variadic forms:
    if (typeof fp !== 'function') {
      options = x0;
      x0 = fp;
      fp = null;
    }

    options = options || {};
    tol = options.tolerance === undefined ? 1e-7 : options.tolerance;
    eps = options.epsilon === undefined ? 2.220446049250313e-16 : options.epsilon;
    maxIter = options.maxIterations === undefined ? 20 : options.maxIterations;
    h = options.h === undefined ? 1e-4 : options.h;
    verbose = options.verbose === undefined ? false : options.verbose;
    hr = 1 / h;

    iter = 0;
    while (iter++ < maxIter) {
      // Compute the value of the function:
      y = f(x0);

      if (fp) {
        yp = fp(x0);
      } else {
        // Needs numerical derivatives:
        yph = f(x0 + h);
        ymh = f(x0 - h);
        yp2h = f(x0 + 2 * h);
        ym2h = f(x0 - 2 * h);

        yp = ((ym2h - yp2h) + 8 * (yph - ymh)) * hr / 12;
      }

      // Check for badly conditioned update (extremely small first deriv relative to function):
      if (Math.abs(yp) <= eps * Math.abs(y)) {
        if (verbose) {
          console.log('Newton-Raphson: failed to converged due to nearly zero first derivative');
        }
        return false;
      }

      // Update the guess:
      x1 = x0 - y / yp;

      // Check for convergence:
      if (Math.abs(x1 - x0) <= tol * Math.abs(x1)) {
        if (verbose) {
          console.log('Newton-Raphson: converged to x = ' + x1 + ' after ' + iter + ' iterations');
        }
        return x1;
      }

      // Transfer update to the new guess:
      x0 = x1;
    }

    if (verbose) {
      console.log('Newton-Raphson: Maximum iterations reached (' + maxIter + ')');
    }

    return false;
  }

  private convert(data) {
    if (!data || !data.length || !data.forEach || data.length < 2) {
      throw new Error('Argument is not an array with length of 2 or more.');
    }

    var investments = [];
    var start = Math.floor(data[0].when/this.MILLIS_PER_DAY);
    var end = start;
    var minAmount = Number.POSITIVE_INFINITY;
    var maxAmount = Number.NEGATIVE_INFINITY;
    var total = 0;
    var deposits = 0;
    data.forEach((datum) => {
      total += datum.amount;
      if (datum.amount < 0) {
        deposits += -datum.amount;
      }
      var epochDays = Math.floor(datum.when / this.MILLIS_PER_DAY);
      start = Math.min(start, epochDays);
      end = Math.max(end, epochDays);
      minAmount = Math.min(minAmount, datum.amount);
      maxAmount = Math.max(maxAmount, datum.amount);
      investments.push({
        amount: datum.amount,
        epochDays: epochDays
      });
    });
    if (start === end) {
      throw new Error('Transactions must not all be on the same day.');
    }
    if (minAmount >= 0) {
      throw new Error('Transactions must not all be nonnegative.');
    }
    if (maxAmount < 0) {
      throw new Error('Transactions must not all be negative.');
    }
    investments.forEach((investment) => {
      // Number of years (including fraction) this item applies
      investment.years = (end - investment.epochDays) / this.DAYS_IN_YEAR;
    });
    return {
      total: total,
      deposits: deposits,
      days: end - start,
      investments: investments,
      maxAmount: maxAmount
    };
  }

  private xirr(transactions, options) {
    var data = this.convert(transactions);
    if (data.maxAmount === 0) {
      return -1;
    }
    var investments = data.investments;
    var value = function(rate) {
      return investments.reduce(function(sum, investment) {
        // Make the vars more Math-y, makes the derivative easier to see
        var A = investment.amount;
        var Y = investment.years;
        if (-1 < rate) {
          return sum + A * Math.pow(1+rate, Y);
        } else if (rate < -1) {
          // Extend the function into the range where the rate is less
          // than -100%.  Even though this does not make practical sense,
          // it allows the algorithm to converge in the cases where the
          // candidate values enter this range

          // We cannot use the same formula as before, since the base of
          // the exponent (1+rate) is negative, this yields imaginary
          // values for fractional years.
          // E.g. if rate=-1.5 and years=.5, it would be (-.5)^.5,
          // i.e. the square root of negative one half.

          // Ensure the values are always negative so there can never
          // be a zero (as long as some amount is non-zero).
          // This formula also ensures that the derivative is positive
          // (when rate < -1) so that Newton's method is encouraged to
          // move the candidate values towards the proper range

          return sum - Math.abs(A) * Math.pow(-1-rate, Y);
        } else if (Y === 0) {
          return sum + A;  // Treat 0^0 as 1
        } else {
          return sum;
        }
      }, 0);
    };
    var derivative = function(rate) {
      return investments.reduce(function(sum, investment) {
        // Make the vars more Math-y, makes the derivative easier to see
        var A = investment.amount;
        var Y = investment.years;
        if (Y === 0) {
          return sum;
        } else if (-1 < rate) {
          return sum + A * Y * Math.pow(1+rate, Y-1);
        } else if (rate < -1) {
          return sum + Math.abs(A) * Y * Math.pow(-1-rate, Y-1);
        } else {
          return sum;
        }
      }, 0);
    };
    var guess = options ? options.guess : undefined;
    if (guess && isNaN(guess)) {
      throw new Error("option.guess must be a number.");
    }
    if (!guess) {
      guess = (data.total / data.deposits) / (data.days/this.DAYS_IN_YEAR);
    }
    var rate = this.newtonRaphson(value, derivative, guess, options);
    if (rate === false) {  // truthiness strikes again, !rate is true when rate is zero
      throw new Error("Newton-Raphson algorithm failed to converge.");
    }
    return rate;
  }
}
